module.exports = __webpack_public_path__ + "static/media/cybathlon_DIV_08(1)_cropped.98f64605.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle11/cybathlon_DIV_08(1)_cropped.jpg
 ** module id = 147
 ** module chunks = 0
 **/